var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "separator-container d-flex align-items-center" },
    [
      _c("div", { staticClass: "separator me-1" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "circle d-flex align-items-center justify-content-center",
        },
        [_c("i", { staticClass: "icon", class: _vm.iconClass })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "separator ms-1" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }